import React from "react";
import { MdStar } from "react-icons/md";

import styles from "./AddressCard.module.scss";
import { FullAddressInterface } from "../../../common/types/interfaces";

interface Props {
  address: FullAddressInterface;
  isSelected: boolean;
  onSelect: (addressId: number) => void;
}

export const AddressCard: React.FC<Props> = ({
  address,
  isSelected,
  onSelect,
}) => {
  const details = [
    address.apartment && `кв. ${address.apartment}`,
    address.entrance && `под. ${address.entrance}`,
    address.floor && `эт. ${address.floor}`,
    address.intercom && `домофон ${address.intercom}`,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <button
      type="button"
      className={`${styles.Card} ${isSelected ? styles.Selected : ""}`}
      onClick={() => onSelect(address.id)}
    >
      <div className={styles.Header}>
        <span className={styles.Name}>{address.name}</span>
        {address.isGeneral && (
          <span className={styles.DefaultBadge}>
            <MdStar size={12} />
            Основной
          </span>
        )}
      </div>

      <span className={styles.Address}>
        {[address.city?.value, address.address?.value]
          .filter(Boolean)
          .join(", ")}
      </span>

      {details && <span className={styles.Details}>{details}</span>}

      {address.description && (
        <span className={styles.Comment}>{address.description}</span>
      )}
    </button>
  );
};